// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.assistant-review-page {
  padding: 24px;
  color: #233249;
  max-width: 1440px;
  margin: auto;
  box-sizing: border-box;
}
.assistant-review-page * {
  box-sizing: border-box;
}
.assistant-review-page h1 {
  font-size: 24px;
}
.assistant-review-page h2 {
  font-size: 19px;
}
.assistant-review-page h3 {
  font-size: 16px;
}
.assistant-review-page p {
  line-height: 1.55;
}
.assistant-review-page header > p {
  color: #62718a;
}
.assistant-review-page button, .assistant-review-page input, .assistant-review-page select, .assistant-review-page textarea {
  font: inherit;
}
.assistant-review-page button {
  cursor: pointer;
  min-height: 44px;
  padding: 10px 14px;
  border: 1px solid #dbe2ec;
  background: white;
  border-radius: 10px;
  color: #26394f;
}
.assistant-review-page button:disabled {
  opacity: 0.5;
  cursor: default;
}
.assistant-review-page input:not([type=checkbox]), .assistant-review-page select, .assistant-review-page textarea {
  min-height: 44px;
  padding: 10px;
  width: 100%;
  border: 1px solid #dbe2ec;
  border-radius: 9px;
  background: white;
  color: #233249;
  min-width: 0;
}
.assistant-review-page label {
  display: grid;
  gap: 6px;
  font-size: 13px;
}
.assistant-review-page textarea {
  resize: vertical;
}
.assistant-review-page .assistant-review-toolbar {
  display: flex;
  align-items: end;
  gap: 14px;
  flex-wrap: wrap;
  margin: 18px 0;
}
.assistant-review-page .assistant-review-toolbar label {
  min-width: 220px;
}
.assistant-review-page .assistant-review-toolbar > span {
  padding-bottom: 12px;
  color: #62718a;
  font-size: 12px;
}
.assistant-review-page .assistant-review-columns {
  display: grid;
  grid-template-columns: minmax(230px, 0.8fr) minmax(0, 1.7fr);
  gap: 20px;
  align-items: start;
}
.assistant-review-page .assistant-review-list {
  display: grid;
  gap: 8px;
}
.assistant-review-page .assistant-review-list > button {
  text-align: left;
  display: grid;
  gap: 6px;
  width: 100%;
  padding: 14px;
}
.assistant-review-page .assistant-review-list > button strong {
  overflow-wrap: anywhere;
}
.assistant-review-page .assistant-review-list > button span, .assistant-review-page .assistant-review-list > button small {
  font-size: 11px;
  color: #65768c;
}
.assistant-review-page .assistant-review-list > button.is-selected {
  border-color: #db3957;
  background: #fff4f6;
}
.assistant-review-page .assistant-review-detail {
  min-width: 0;
  padding: 20px;
  background: white;
  border: 1px solid #e2e7ee;
  border-radius: 14px;
}
.assistant-review-page .assistant-review-detail form {
  display: grid;
  gap: 16px;
  margin-top: 20px;
}
.assistant-review-page .assistant-review-detail fieldset {
  min-width: 0;
  border: 1px solid #dbe2ec;
  border-radius: 12px;
  padding: 16px;
  display: grid;
  gap: 12px;
}
.assistant-review-page .assistant-review-detail fieldset p {
  font-size: 12px;
  color: #62718a;
  margin: 0;
}
.assistant-review-page .assistant-review-detail summary {
  cursor: pointer;
  min-height: 44px;
  display: flex;
  align-items: center;
  color: #53677f;
}
.assistant-review-page .assistant-review-text {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
.assistant-review-page .assistant-review-meta {
  font-size: 12px;
  color: #68788d;
}
.assistant-review-page .assistant-review-check {
  display: flex;
  align-items: start;
  gap: 9px;
  line-height: 1.5;
}
.assistant-review-page .assistant-review-check input {
  width: 20px;
  height: 20px;
  margin: 0;
  flex-shrink: 0;
}
.assistant-review-page .assistant-review-primary {
  justify-self: start;
  background: #db2f4f;
  color: white;
  border-color: #db2f4f;
}
.assistant-review-page .assistant-review-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 10px;
}
.assistant-review-page .assistant-review-history {
  border-top: 1px solid #e4e9ef;
  padding: 12px 0;
  font-size: 12px;
}
.assistant-review-page .assistant-review-history small {
  display: block;
  color: #65768c;
  margin-top: 4px;
}
.assistant-review-page .assistant-review-error {
  color: #a92b46;
  background: #fff0f3;
  padding: 12px;
  border-radius: 10px;
}
.assistant-review-page .assistant-review-success {
  color: #267453;
  background: #eef8f1;
  padding: 12px;
  border-radius: 10px;
}

@media (max-width: 800px) {
  .assistant-review-page {
    padding: 16px;
  }
  .assistant-review-page .assistant-review-columns {
    grid-template-columns: 1fr;
  }
  .assistant-review-page .assistant-review-detail {
    padding: 14px;
  }
}
.assistant-admin-history {
  width: 100%;
  overflow-wrap: anywhere;
}
.assistant-admin-history .assistant-history-turn {
  padding: 20px 0;
  border-top: 1px solid #e2e7ee;
}
.assistant-admin-history .assistant-history-turn > header {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}
.assistant-admin-history .assistant-history-turn > header small {
  color: #62718a;
}
.assistant-admin-history .assistant-history-feedback {
  border-radius: 10px;
  background: #f7f9fc;
  padding: 12px;
}
.assistant-admin-history .assistant-history-feedback a {
  color: #a82540;
}
.assistant-admin-history .assistant-review-list span, .assistant-admin-history .assistant-review-list small {
  overflow-wrap: anywhere;
}
.assistant-admin-history .assistant-review-toolbar label {
  max-width: 100%;
  min-width: min(220px, 100%);
}

.assistant-admin-history .assistant-history-sidebar {
  position: sticky;
  top: 16px;
  min-width: 0;
}
.assistant-admin-history .assistant-history-list-scroll {
  max-height: 60vh;
  max-height: 60dvh;
  overflow-y: auto;
  overscroll-behavior-y: contain;
  scrollbar-gutter: stable;
  align-content: start;
  padding: 2px 6px 2px 2px;
}

@media (max-width: 800px) {
  .assistant-admin-history .assistant-history-sidebar {
    position: static;
  }
  .assistant-admin-history .assistant-history-list-scroll {
    max-height: 40vh;
    max-height: 40dvh;
  }
}`, "",{"version":3,"sources":["webpack://./src/modules/assistant/assistantFeedback.scss"],"names":[],"mappings":"AAAA;EAAyB,aAAA;EAAe,cAAA;EAAgB,iBAAA;EAAmB,YAAA;EAAc,sBAAA;AAMzF;AANiH;EAAI,sBAAA;AASrH;AAT+I;EAAK,eAAA;AAYpJ;AAZuK;EAAK,eAAA;AAe5K;AAf+L;EAAK,eAAA;AAkBpM;AAlBuN;EAAI,iBAAA;AAqB3N;AArBgP;EAAa,cAAA;AAwB7P;AAxB+Q;EAAkC,aAAA;AA2BjT;AA3BkU;EAAS,eAAA;EAAiB,gBAAA;EAAkB,kBAAA;EAAoB,yBAAA;EAA2B,iBAAA;EAAmB,mBAAA;EAAqB,cAAA;AAoCrc;AApCqd;EAAa,YAAA;EAAa,eAAA;AAwC/e;AAxCogB;EAAiD,gBAAA;EAAkB,aAAA;EAAe,WAAA;EAAa,yBAAA;EAA2B,kBAAA;EAAoB,iBAAA;EAAmB,cAAA;EAAgB,YAAA;AAkDrrB;AAlDqsB;EAAQ,aAAA;EAAe,QAAA;EAAU,eAAA;AAuDtuB;AAvDyvB;EAAW,gBAAA;AA0DpwB;AA1DwxB;EAA4B,aAAA;EAAe,gBAAA;EAAkB,SAAA;EAAW,eAAA;EAAiB,cAAA;AAiEj3B;AAjEi4B;EAAQ,gBAAA;AAoEz4B;AApE65B;EAAS,oBAAA;EAAsB,cAAA;EAAgB,eAAA;AAyE58B;AAzEi+B;EAA4B,aAAA;EAAe,4DAAA;EAA6D,SAAA;EAAW,kBAAA;AA+EplC;AA/E0mC;EAAyB,aAAA;EAAe,QAAA;AAmFlpC;AAnF4pC;EAAW,gBAAA;EAAkB,aAAA;EAAe,QAAA;EAAU,WAAA;EAAa,aAAA;AA0F/tC;AA1F8uC;EAAS,uBAAA;AA6FvvC;AA7FkxC;EAAc,eAAA;EAAiB,cAAA;AAiGjzC;AAjGm0C;EAAgB,qBAAA;EAAuB,mBAAA;AAqG12C;AArGq4C;EAA2B,YAAA;EAAc,aAAA;EAAe,iBAAA;EAAmB,yBAAA;EAA2B,mBAAA;AA4G3+C;AA5GggD;EAAO,aAAA;EAAe,SAAA;EAAW,gBAAA;AAiHjiD;AAjHqjD;EAAW,YAAA;EAAc,yBAAA;EAA2B,mBAAA;EAAqB,aAAA;EAAe,aAAA;EAAe,SAAA;AAyH5pD;AAzHuqD;EAAI,eAAA;EAAiB,cAAA;EAAgB,SAAA;AA8H5sD;AA9H2tD;EAAU,eAAA;EAAiB,gBAAA;EAAkB,aAAA;EAAe,mBAAA;EAAqB,cAAA;AAqI5yD;AArIg0D;EAAyB,qBAAA;EAAuB,uBAAA;AAyIh3D;AAzI24D;EAAyB,eAAA;EAAiB,cAAA;AA6Ir7D;AA7Iu8D;EAA0B,aAAA;EAAe,kBAAA;EAAoB,QAAA;EAAU,gBAAA;AAmJ9gE;AAnJgiE;EAAQ,WAAA;EAAa,YAAA;EAAc,SAAA;EAAW,cAAA;AAyJ9kE;AAzJkmE;EAA4B,mBAAA;EAAqB,mBAAA;EAAqB,YAAA;EAAc,qBAAA;AA+JtrE;AA/J+sE;EAA+B,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,QAAA;EAAU,gBAAA;AAsK5zE;AAtKg1E;EAA4B,6BAAA;EAA+B,eAAA;EAAiB,eAAA;AA2K55E;AA3K66E;EAAQ,cAAA;EAAgB,cAAA;EAAgB,eAAA;AAgLr9E;AAhL0+E;EAA0B,cAAA;EAAgB,mBAAA;EAAqB,aAAA;EAAe,mBAAA;AAsLxjF;AAtL+kF;EAA4B,cAAA;EAAgB,mBAAA;EAAqB,aAAA;EAAe,mBAAA;AA4L/pF;;AA3LA;EAA2B;IAAyB,aAAA;EAgMlD;EAhMiE;IAA4B,0BAAA;EAmM7F;EAnM2H;IAA2B,aAAA;EAsMtJ;AACF;AAtMA;EAA2B,WAAA;EAAa,uBAAA;AA0MxC;AA1MiE;EAA0B,eAAA;EAAiB,6BAAA;AA8M5G;AA9M2I;EAAW,aAAA;EAAe,8BAAA;EAAgC,SAAA;EAAW,eAAA;AAoNhN;AApNiO;EAAQ,cAAA;AAuNzO;AAvN+P;EAA8B,mBAAA;EAAqB,mBAAA;EAAqB,aAAA;AA4NvU;AA5NsV;EAAI,cAAA;AA+N1V;AA/N8W;EAA4D,uBAAA;AAkO1a;AAlOqc;EAAkC,eAAA;EAAiB,2BAAA;AAsOxf;;AApOI;EAA6B,gBAAA;EAAkB,SAAA;EAAW,YAAA;AA0O9D;AAzOI;EACI,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,8BAAA;EACA,wBAAA;EACA,oBAAA;EACA,wBAAA;AA2OR;;AAxOA;EAEQ;IAA6B,gBAAA;EA2OnC;EA1OM;IAAiC,gBAAA;IAAkB,iBAAA;EA8OzD;AACF","sourcesContent":[".assistant-review-page { padding: 24px; color: #233249; max-width: 1440px; margin: auto; box-sizing: border-box; * { box-sizing: border-box; } h1 { font-size: 24px; } h2 { font-size: 19px; } h3 { font-size: 16px; } p { line-height: 1.55; } header > p { color: #62718a; } button, input, select, textarea { font: inherit; } button { cursor: pointer; min-height: 44px; padding: 10px 14px; border: 1px solid #dbe2ec; background: white; border-radius: 10px; color: #26394f; &:disabled { opacity: .5; cursor: default; } } input:not([type=\"checkbox\"]), select, textarea { min-height: 44px; padding: 10px; width: 100%; border: 1px solid #dbe2ec; border-radius: 9px; background: white; color: #233249; min-width: 0; } label { display: grid; gap: 6px; font-size: 13px; } textarea { resize: vertical; } .assistant-review-toolbar { display: flex; align-items: end; gap: 14px; flex-wrap: wrap; margin: 18px 0; label { min-width: 220px; } > span { padding-bottom: 12px; color: #62718a; font-size: 12px; } } .assistant-review-columns { display: grid; grid-template-columns: minmax(230px, .8fr) minmax(0, 1.7fr); gap: 20px; align-items: start; } .assistant-review-list { display: grid; gap: 8px; > button { text-align: left; display: grid; gap: 6px; width: 100%; padding: 14px; strong { overflow-wrap: anywhere; } span, small { font-size: 11px; color: #65768c; } &.is-selected { border-color: #db3957; background: #fff4f6; } } } .assistant-review-detail { min-width: 0; padding: 20px; background: white; border: 1px solid #e2e7ee; border-radius: 14px; form { display: grid; gap: 16px; margin-top: 20px; } fieldset { min-width: 0; border: 1px solid #dbe2ec; border-radius: 12px; padding: 16px; display: grid; gap: 12px; p { font-size: 12px; color: #62718a; margin: 0; } } summary { cursor: pointer; min-height: 44px; display: flex; align-items: center; color: #53677f; } } .assistant-review-text { white-space: pre-wrap; overflow-wrap: anywhere; } .assistant-review-meta { font-size: 12px; color: #68788d; } .assistant-review-check { display: flex; align-items: start; gap: 9px; line-height: 1.5; input { width: 20px; height: 20px; margin: 0; flex-shrink: 0; } } .assistant-review-primary { justify-self: start; background: #db2f4f; color: white; border-color: #db2f4f; } .assistant-review-pagination { display: flex; align-items: center; justify-content: space-between; gap: 8px; margin-top: 10px; } .assistant-review-history { border-top: 1px solid #e4e9ef; padding: 12px 0; font-size: 12px; small { display: block; color: #65768c; margin-top: 4px; } } .assistant-review-error { color: #a92b46; background: #fff0f3; padding: 12px; border-radius: 10px; } .assistant-review-success { color: #267453; background: #eef8f1; padding: 12px; border-radius: 10px; } }\n@media(max-width: 800px) { .assistant-review-page { padding: 16px; .assistant-review-columns { grid-template-columns: 1fr; } .assistant-review-detail { padding: 14px; } } }\n.assistant-admin-history { width: 100%; overflow-wrap: anywhere; .assistant-history-turn { padding: 20px 0; border-top: 1px solid #e2e7ee; > header { display: flex; justify-content: space-between; gap: 12px; flex-wrap: wrap; small { color: #62718a; } } } .assistant-history-feedback { border-radius: 10px; background: #f7f9fc; padding: 12px; a { color: #a82540; } } .assistant-review-list span, .assistant-review-list small { overflow-wrap: anywhere; } .assistant-review-toolbar label { max-width: 100%; min-width: min(220px, 100%); } }\n.assistant-admin-history {\n    .assistant-history-sidebar { position: sticky; top: 16px; min-width: 0; }\n    .assistant-history-list-scroll {\n        max-height: 60vh;\n        max-height: 60dvh;\n        overflow-y: auto;\n        overscroll-behavior-y: contain;\n        scrollbar-gutter: stable;\n        align-content: start;\n        padding: 2px 6px 2px 2px;\n    }\n}\n@media(max-width: 800px) {\n    .assistant-admin-history {\n        .assistant-history-sidebar { position: static; }\n        .assistant-history-list-scroll { max-height: 40vh; max-height: 40dvh; }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
